export type TooltipItem = {
  label: string;
  value: string;
};
